module.exports = __webpack_public_path__ + "static/media/Error-art.58c5dbd5.png";